import { motion } from "framer-motion";
import { FaGithub, FaEnvelope, FaLinkedin } from "react-icons/fa";
import CustomCursor from "../components/CustomCursor";




const Contact = () => {
  return (
    <>
    <CustomCursor/>
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 text-white bg-animated-gradient relative z-10">
        
      {/* Header */}
      <motion.h1
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl sm:text-5xl font-bold mb-4 text-center text-purple-400"
      >
        Let’s Connect
      </motion.h1>

      {/* Subtext */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-gray-400 text-md text-center max-w-xl mb-10"
      >
        Have an idea, project, or opportunity in mind? I’m all ears.
      </motion.p>

      {/* Contact Form */}
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="space-y-6 w-full max-w-xl"
        action="https://formsubmit.co/ramkarth1234@gmail.com"  
        method="POST"
      >
        {/* Prevent CAPTCHA and redirect after submit */}
        <input type="hidden" name="_captcha" value="false" />
        

        <input
          type="text"
          name="name"
          required
          placeholder="Your Name"
          className="w-full px-5 py-3 bg-white/5 backdrop-blur text-white border border-white/10 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
        <input
          type="email"
          name="email"
          required
          placeholder="Your Email"
          className="w-full px-5 py-3 bg-white/5 backdrop-blur text-white border border-white/10 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
        <textarea
          name="message"
          required
          placeholder="Your Message"
          rows={5}
          className="w-full px-5 py-3 bg-white/5 backdrop-blur text-white border border-white/10 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
        <button
          type="submit"
          className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3 rounded-md transition-all duration-300"
        >
          Send Message
        </button>
      </motion.form>

      {/* Social Icons */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
        className="mt-12 flex space-x-6"
      >
        <a
          href="https://github.com/karthik807"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-purple-400 transition"
        >
          <FaGithub size={24} />
        </a>
        <a
          href="mailto:ramkarth1234@gmail.com"
          className="hover:text-purple-400 transition"
        >
          <FaEnvelope size={24} />
        </a>
        <a
          href="https://linkedin.com/in/kram0101"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-purple-400 transition"
        >
          <FaLinkedin size={24} />
        </a>
      </motion.div>
    </div>
    </>
  );
};

export default Contact;